import { ConversationAPI, CustomerAPI } from 'api'

export const getConversationById = (id) => (
  ConversationAPI.get(`/conversations/${id}`)
)

export const getMostRecentMessages = (conversationId, numberOfMessages) => (
  ConversationAPI.get(`/conversations/${conversationId}/messages/page?limit=${numberOfMessages}`)
)

export const getUserById = (id) => (
  CustomerAPI.get(`/users/${id}`)
)